import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { useAssignUnitsByWorkOrder } from "../../projectManagementQueries";
import { BomDetailsTable } from "./BomDetailsTable";

export const BomDetailsDialog = ({ open, handleclose, workOrderId, projectnumber, customer, bomname }: any) => {



    const {
        data: workOrderUnitsData,
        isError: isErrorWorkOrderUnits,
        isSuccess: isSuccessWorkOrderUnits,
        error: errorWorkOrderUnits,
        isLoading: isLoadingWorkOrderUnits,
    } = useAssignUnitsByWorkOrder(workOrderId);




    return (
        <>
            <Dialog open={open} onClose={handleclose} fullWidth maxWidth="lg" >
                <DialogTitle>
                    <div>
                        <Grid container style={{ display: "flex", alignItems: "center" }}>
                            <Grid item xs={11} >Work Order Units</Grid>
                            <Grid item xs={1} style={{ textAlign: "right" }}>
                                <IconButton onClick={handleclose}>
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent >
                    {isLoadingWorkOrderUnits ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="200px"
                            width="100%"
                        >
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        workOrderUnitsData && (
                            <>
                                <Grid container spacing={1} style={{ marginTop: "10px", marginLeft: "30px", marginRight: "30px", width: "1000px" }}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ color: "#800280", fontSize: "18px" }}>
                                            Project Number: {projectnumber}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ color: "#800280", fontSize: "18px" }}>
                                            Customer Name: {customer}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ color: "#800280", fontSize: "18px" }}>
                                            BOM : {bomname}
                                        </Typography>

                                    </Grid>
                                </Grid>
                                <Grid container style={{ marginTop: "10px", marginLeft: "60px", marginRight: "30px", width: "1100px" }}>
                                    {workOrderUnitsData.units && (
                                        <Grid item xs={12} >
                                            <BomDetailsTable data={workOrderUnitsData.units} />
                                        </Grid>
                                    )}

                                </Grid>

                            </>
                        )
                    )}
                </DialogContent>

            </Dialog>



        </>
    )
}